import { render, staticRenderFns } from "./modalAdicionarEditarItensPedidoExistente.vue?vue&type=template&id=08e1f5a2&scoped=true&"
import script from "./modalAdicionarEditarItensPedidoExistente.vue?vue&type=script&lang=js&"
export * from "./modalAdicionarEditarItensPedidoExistente.vue?vue&type=script&lang=js&"
import style0 from "./modalAdicionarEditarItensPedidoExistente.vue?vue&type=style&index=0&id=08e1f5a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e1f5a2",
  null
  
)

export default component.exports